import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';

interface UseFieldErrorParams {
  elementId?: string;
  path: string;
}

function buildErrorKey(elementId: string | undefined, path: string): string {
  return elementId !== undefined ? `${elementId}.${path}` : path;
}

export function useFieldError({ elementId, path }: UseFieldErrorParams) {
  const errorKey = buildErrorKey(elementId, path);
  return QuestionnaireTemplateStore.useStoreState((s) => s.errors[errorKey] ?? null);
}
